import { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Alert, Stack } from '@mui/material';
import { supabase } from '../lib/supabaseClient';
import { validateEmail } from '../lib/validation';
import { useNavigate } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + '/reset-password',
      });
      if (error) throw error;
      setSuccess('Password reset email sent! Please check your inbox.');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" bgcolor="#f5f5f5">
      <Card sx={{ minWidth: { xs: '100%', sm: 350 }, p: { xs: 2, sm: 4 } }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>Forgot Password</Typography>
          <form onSubmit={handleSendEmail}>
            <Stack spacing={2}>
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                fullWidth
              />
              {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>}
              <Button
                type="submit"
                variant="contained"
                color="error"
                disabled={loading}
                fullWidth
              >
                {loading ? 'Sending...' : 'Send Email'}
              </Button>
              <Button
                color="error"
                onClick={() => navigate('/login')}
                fullWidth
              >
                Back to Login
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
